import { amplitude } from "./amplitude"

/**
 * Replace UUIDs in URL paths with {id} for stable event names.
 */
function normalizeUrlPath(url: string): string {
  try {
    const path = new URL(url, "http://localhost").pathname
    return path.replace(
      /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
      "{id}",
    )
  } catch {
    return url
  }
}

/**
 * Auto-track an API call completion.
 * Event name format: api_{method}_{normalized_path}
 */
export function trackApiCall(
  method: string,
  url: string,
  status: number,
  durationMs: number,
): void {
  try {
    const normalizedPath = normalizeUrlPath(url)
    amplitude.track(`api_${method.toLowerCase()}_${normalizedPath}`, {
      method,
      url: normalizedPath,
      status,
      duration_ms: durationMs,
    })
  } catch {
    // fail silently
  }
}

/**
 * Auto-track an API error.
 */
export function trackApiError(
  method: string,
  url: string,
  status: number,
  requestId: string | null,
  errorMessage: string | undefined,
): void {
  try {
    const normalizedPath = normalizeUrlPath(url)
    amplitude.track("api_error", {
      method,
      url: normalizedPath,
      status,
      request_id: requestId,
      error_message: errorMessage,
    })
  } catch {
    // fail silently
  }
}

/**
 * Auto-track a page view.
 */
export function trackPageView(pathname: string): void {
  try {
    amplitude.track("page_view", {
      pathname,
    })
  } catch {
    // fail silently
  }
}
